import { dates } from './dates'
import { notifications } from './notifications'
import { images } from './images'

export const mixin = {
  dates,
  notifications,
  images
}



// WEBPACK FOOTER //
// ./src/mixins/index.js